import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, computed } from '@angular/core';

import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { PlayerStatInfo, VisualizationConstants } from '../../models/my-bets-visualization-types';
import { MyBetsVisualizationService } from '../../services/my-bets-visualization.service';
import { VisualizationBaseComponent } from './visualization-base.component';

@Component({
    imports: [NgClass],
    selector: 'ms-my-bets-target-visualization',
    templateUrl: 'my-bets-target-visualization.component.html',
    styleUrl: './my-bets-target-visualization.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyBetsTargetVisualizationComponent extends VisualizationBaseComponent {
    @HostBinding('class') className = 'live-bets-tracking';

    constructor(private myBetsVisualizationService: MyBetsVisualizationService) {
        super();
    }

    private resetStats = computed(() => this.computeResetStats());

    targetStatValue = computed(() => this.resetStats().targetStat.join('-'));

    progressBarWidth = computed(() => this.calculateProgressBarWidth());

    betStateClassName = computed(() =>
        this.myBetsVisualizationService.getBetStateClassName(this.betMarketInfo().state, this.currentStatValue(), this.isCashedOut()),
    );

    override currentStatValue = computed(() => this.calculateCurrentStatValue());

    private computeResetStats(): PlayerStatInfo {
        const resetStats = { ...this.statsData() };
        const stats = this.myBetsVisualizationService.marketStatsDetails(this.event(), this.betMarketInfo().marketId);

        if (!this.shouldResetStats(stats, resetStats.player.playerId)) {
            return resetStats;
        }

        return this.resetStatsForTeamPlay(resetStats);
    }

    private shouldResetStats(stats: { statsType: string }, playerId: number | undefined): boolean {
        return stats.statsType === VisualizationConstants.Team && !!this.event().fixtureScoreboard && !!playerId;
    }

    private resetStatsForTeamPlay(resetStats: PlayerStatInfo): PlayerStatInfo {
        const { playerName } = resetStats.player;

        if (playerName === VisualizationConstants.HomePlayer) {
            resetStats.player2CurrStat = 0;
        } else if (playerName === VisualizationConstants.AwayPlayer) {
            resetStats.player1CurrStat = 0;
        }

        return resetStats;
    }

    private calculateProgressBarWidth(): string {
        const currentStat = this.currentStatValue();
        const targetStat = this.resetStats().targetStat;

        if (currentStat <= targetStat[0]) {
            return `calc((80% / ${targetStat[0]}) * ${currentStat})`;
        }

        if (targetStat.length > 1 && currentStat >= targetStat[0] && currentStat <= targetStat[1]) {
            return '80%';
        }

        return this.myBetsListContext().listType !== BetslipListType.Settled ? '90%' : '100%';
    }

    private calculateCurrentStatValue(): number {
        return this.resetStats().player1CurrStat + this.resetStats().player2CurrStat;
    }
}
